/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Icon, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, useTheme, Typography, Card, CardContent, CardActions, Chip } from '@mui/material';
import { Send, Edit, Delete } from '@mui/icons-material';

import { ToolsListing } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { useAuthContext } from '../../context';
import { IListEmpreendimentos, OrganizationServices } from '../../services/api/organization/OrganizationServices';
import { CustomAlert } from '../../components/shared/VAlert';
import { ConfirmationDialog } from '../../components/shared/VConfirmationDialog';


export const ListOrganization: React.FC = () => {

    const navigate = useNavigate();
    const [rows, setRows] = useState<IListEmpreendimentos[]>();
    const { userData } = useAuthContext();
    const [data, setData] = useState<IListEmpreendimentos[]>();
    const [searchText, setSearchText] = useState('');
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [selectedUuid, setSelectedUuid] = useState<string | null>(null);
    const [loadin, setLoadin] = useState<boolean>(false);

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setAlertInfo({ open: false, message: '', severity: 'info' });
        setTimeout(() => {
            setAlertInfo({ open: true, message, severity });
        }, 100);
    };

    function handleDeleteClick(uuid: string) {
        setSelectedUuid(uuid);
        setDialogOpen(true);
    }

    async function handleConfirmDelete() {
        if (selectedUuid !== null) {
            OrganizationServices.delet(selectedUuid)
                .then((result: { message: any; }) => {
                    if (result instanceof Error) {
                        showAlert(`Erro ao excluir! - ${result.message}`, 'error');
                        console.log(result.message);
                    } else {
                        showAlert('Unidade/Empreendimento excluído!', 'success');
                        setSelectedUuid(null);
                        setTimeout(() => {
                            fetchData();
                        }, 1000);
                    }
                });
        }
        setDialogOpen(false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoadin(true);
        const level = userData.nivel;

        if (level === 'adm') {
            OrganizationServices.listAdm()
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({ open: true, message: 'Não foi possível obter unidades/empreendimentos!', severity: 'error' });
                        setLoadin(false);
                    } else {
                        if (response.length > 0) {
                            setData(response);
                            setLoadin(false);
                        } else {
                            setLoadin(false);
                            setAlertInfo({ open: true, message: 'Não existem unidades cadastradas!', severity: 'info' });
                            // navigate('/company_organization/detalhes/novo');
                        }
                    }
                });
        } else {
            if (userData.id_empresa) {
                OrganizationServices.get(userData.id_empresa)
                    .then((result) => {
                        if (result instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível obter unidades/empreendimentos!', severity: 'error' });
                            setLoadin(false);
                        } else {
                            const filteredData = result.filter(empreendimento => empreendimento.status === true);
                            if (filteredData.length > 0 && filteredData !== undefined) {
                                setData(filteredData);
                                setLoadin(false);
                            } else if (filteredData == undefined || filteredData.length == 0) {
                                setLoadin(false);
                                setAlertInfo({ open: true, message: 'Não existem unidades cadastradas!', severity: 'info' });
                                navigate('/company_organization/detalhes/novo');
                            }
                        }
                    });
            }
        }
    };


    useEffect(() => {
        if (data !== undefined) {
            const filteredData = data.filter(empreendimento =>
                empreendimento.nome_fantasia.toLowerCase().includes(searchText.toLowerCase())
            );
            setRows(filteredData);
        }
    }, [data, searchText]);

    const MobileOrganizationCard = ({ row }: { row: IListEmpreendimentos }) => (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: '15px' }}>
            <CardContent>
                <Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    <Typography variant="h6" component="div" sx={{ wordBreak: 'break-word', flex: 1, mr: 1 }}>
                        {row.nome_fantasia}
                    </Typography>
                    <Chip
                        label={row.empresa}
                        size="small"
                        color="primary"
                        variant="outlined"
                    />
                </Box>

                {userData.nivel === 'adm' && (
                    <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
                        Status: {row.status === true ? 'Ativo' : 'Desativado'}
                    </Typography>
                )}
            </CardContent>

            <CardActions sx={{ flexDirection: 'column', gap: 1, p: 2, pt: 0 }}>
                <Button
                    color='primary'
                    variant="contained"
                    sx={{ borderRadius: '25px' }}
                    startIcon={<Send />}
                    onClick={() => navigate(`/company_dam/${row.uuid}`)}
                    fullWidth
                    size="small"
                >
                    Barragens
                </Button>

                {(userData.permissoes.includes('edit') || userData.permissoes.includes('remove')) && (
                    <Box display="flex" gap={1} justifyContent="center" width="100%">
                        {userData.permissoes.includes('edit') && (
                            <Button
                                startIcon={<Edit />}
                                onClick={() => navigate(`/company_organization/detalhes/${row.uuid}`)}
                                size="small"
                                variant="outlined"
                                color="secondary"
                                fullWidth
                            >
                                Editar
                            </Button>
                        )}
                        {userData.permissoes.includes('remove') && (
                            <Button
                                color='error'
                                startIcon={<Delete />}
                                onClick={() => handleDeleteClick(row.uuid)}
                                size="small"
                                variant="outlined"
                                fullWidth
                                disabled={row.status === false}
                            >
                                Excluir
                            </Button>
                        )}
                    </Box>
                )}
            </CardActions>
        </Card>
    );

    return (
        <LayoutBase
            title='Unidades'
            tollBar={
                <ToolsListing
                    textoBotaoNovo='Novo'
                    showNewButton={userData.permissoes.includes('add')}
                    mostrarInputBusca
                    textoDaBusca={searchText}
                    onClickNew={() => navigate('/company_organization/detalhes/novo')}
                    aoMudarTextoBusca={texto => setSearchText(texto)}
                />
            }
        >
            {loadin ?
                <LinearProgress /> :
                <Box width={'100%'}>
                    {smDown ? (
                        <Box px={2} pt={2}>
                            {rows && rows.length > 0 ? (
                                rows.map((row) => (
                                    <MobileOrganizationCard key={row.uuid} row={row} />
                                ))
                            ) : (
                                <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '15px' }}>
                                    <Typography color="text.secondary">
                                        Nenhuma unidade/empreendimento encontrado
                                    </Typography>
                                </Paper>
                            )}
                        </Box>
                    ) : (
                        <Box padding={2} marginLeft={-1}>
                            <TableContainer component={Paper} variant='outlined' sx={{ borderRadius: '25px' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='center'>Nome</TableCell>
                                            <TableCell align='center'>Empresa</TableCell>
                                            <TableCell align='center'>Ações</TableCell>
                                            <TableCell align='center'>Barragens</TableCell>
                                            {userData.nivel === 'adm' ? <TableCell align='center'>Status</TableCell> : null}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows ?
                                            <>
                                                {rows.map(empreendimento => (
                                                    <TableRow key={empreendimento.uuid}>
                                                        <TableCell align='center'>{empreendimento.nome_fantasia}</TableCell>
                                                        <TableCell align='center'>{empreendimento.empresa}</TableCell>
                                                        <TableCell align='center' >
                                                            {userData.permissoes.includes('edit') ?
                                                                <IconButton size='small' onClick={() => navigate(`/company_organization/detalhes/${empreendimento.uuid}`)}>
                                                                    <Icon color='primary'>edit</Icon>
                                                                </IconButton>
                                                                : null
                                                            }
                                                            {userData.permissoes.includes('remove') ?
                                                                <IconButton size='small' onClick={() => handleDeleteClick(empreendimento.uuid)} disabled={empreendimento.status === false}>
                                                                    <Icon color={empreendimento.status === false ? 'disabled' : 'error'}>delete</Icon>
                                                                </IconButton>
                                                                : null
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button color='primary' variant="contained" sx={{ borderRadius: '25px' }} startIcon={<Send />} onClick={() => navigate(`/company_dam/${empreendimento.uuid}`)}>
                                                                Barragens
                                                            </Button>
                                                        </TableCell>
                                                        {userData.nivel === 'adm' ? <TableCell align='center'>{empreendimento.status == true ? 'Ativo' : 'Desativado'}</TableCell> : null}
                                                    </TableRow>
                                                ))}

                                            </> : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}
                </Box>
            }

            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={() => handleConfirmDelete()}
                title='Confirmar Exclusão'
                message='Tem certeza de que deseja excluir este empreendimento?'
            />
        </LayoutBase>
    );
};